export default "__VITE_ASSET__Bvf1JC4N__"